import { CampaignManagementCommand } from "../../../services/command";
import { CampaignStatus } from "../../../types/enums/campaign-enums";

export const StepSummaryServiceComponent = ({ ...props }) => {
  const campaignService = props.campaignService;
  const { campaignDetail, setCampaignDetail, setCampaignDetailInitial, updatedCachedVersion } = campaignService;
  const { campaignRule } = campaignDetail;

  const changeStatus = async (status: number) => {

    let _updatedCacheVersion:any = {}

    switch(status){
      case CampaignStatus.Passive:
      case CampaignStatus.Paused:
      case CampaignStatus.Template:
        _updatedCacheVersion = {
          ...updatedCachedVersion
        }
      break;
      case CampaignStatus.Active:
      case CampaignStatus.Test:
        _updatedCacheVersion = {
          ...updatedCachedVersion,
          reloadAllCampaignRuleMatrix: true,
          reloadAllCampaignRulePriority: true,
          reloadCampaignRuleCoupons: true,
          reloadCampaignRuleProducts: true,
          reloadCampaignRuleEmails: true,
          keywords: [
            campaignRule.descriptionKey,
            campaignRule.offerKey,
          ]
        }
      break;
    }

    let payload = {
      ...campaignDetail,
      campaignRule: {
        ...campaignDetail.campaignRule,
        status: status,
      },
      updateCachedVersion: _updatedCacheVersion,
    };

    const saveResult = await CampaignManagementCommand.SaveCampaign(payload);
    const { isSuccess } = saveResult;
    if (isSuccess) {
      setCampaignDetailInitial(JSON.parse(JSON.stringify(payload)));
      setCampaignDetail(payload);
    }
  };

  const saveForm = () => {
    //campaignService.stepperOnClickNext(event)
  };

  return {
    ...campaignService,
    changeStatus,
    saveForm,
  };
};
